import { FCX } from "@core/models";
import { Header } from "@vms/Header";
import Button from "@components/Button/Button";
import cn from "classnames";

export type ManagementSectionHeaderType = FCX<{
    heading: string;
    reset: () => void;
    isOpened: boolean;
    setIsOpened: (_value: boolean) => void;
}>;

const ManagementSectionHeader: ManagementSectionHeaderType = ({
    heading,
    reset,
    isOpened,
    setIsOpened,
}) => (
    <Header
        rightContent={(
            <Button
                onClick={reset}
                style={{
                    opacity: isOpened ? undefined : 0,
                    pointerEvents: isOpened ? undefined : 'none',
                }}
            >
                reset
            </Button>
        )}
        style={{
            marginBottom: isOpened ? undefined : 0,
        }}
    >
        <span
            className={cn(
                'SurveyDetails__secondary-title',
                isOpened && 'is-open'
            )}
            onClick={() => setIsOpened(!isOpened)}
        >
            <span className="SurveyDetails__secondary-title-icon" />
            {heading}
        </span>
    </Header>
)

export default ManagementSectionHeader;
